<script>
import { watch } from 'vue'
import { useToast } from 'vue-toastification'
import AlertNotification from './AlertNotification.vue'

export default {
  props: {
    flashes: Array,
  },
  setup (props) {
    const toast = useToast()
    let id = 0

    watch(() => props.flashes, (flashes) => {
      flashes.forEach((flashMessage) => {
        ++id;

        toast({
          component: AlertNotification,
          props:  {
            alert: flashMessage.type,
            heading: flashMessage.message.header ? flashMessage.message.header : flashMessage.message,
            message: flashMessage.message.message ? flashMessage.message.message : null,
            toastId: id,
          },
          listeners: {}
        }, {
          id,
          type: flashMessage.type
        })
      })
    }, {immediate: true})

    return () => {} // renderless?
  }
}
</script>